module.exports = __webpack_public_path__ + "img/JAL.d076ed5f.png";